import App from './App.svelte';
import { mount } from "svelte";
import './global.css';

// console.log('prueba log 1 dentro de main.js');

const app = mount(App, {
	target: document.body,
	props: {
		// name: 'world'
	}
});

export default app;